import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function getStatusTranslate(status?: number) {
  const t = getTranslateNsT("center");
  switch (status) {
    case 0:
      return t("student_mod_identify_status_no");
    case 1:
      return t("student_mod_identify_status_ing");
    case 2:
      return t("student_mod_identify_status_ed");
    case 3:
      return t("student_mod_identify_status_failed");
    case 4:
      return t("student_mod_identify_status_expired");
    default:
      break;
  }
}
